import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

// import { DeliverablesPieChart } from './DeliverablesPieChart';
// import { DeliverablesTable } from './DeliverablesTable';
// import { OverviewUpdatesDrawer } from './OverviewUpdatesDrawer';
// import { TaskCenterDrawer } from './TaskCenterDrawer';
// import { useDeliverableContainers } from './useDeliverableContainers';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { Route as LegacyBorrowerRoute } from '~/packages/deliverables/ui/borrower/DeliverablesRoute';
import { Route as LegacyLenderRoute } from '~/packages/deliverables/ui/lender/DeliverablesRoute';

// Fragments
const RouteBase = () => {
  // const deliverableContainers = useDeliverableContainers();
  // if (!deliverableContainers.data || deliverableContainers.loading) {
  //   return <Skeleton height="600px" />;
  // }

  return (
    <>
      <Flex justify="space-between" gap="1rem">
        <Typography variant="page-title" trim>
          Deliverables
        </Typography>
        <Flex gap="1rem">
          {/* <OverviewUpdatesDrawer /> */}
          {/* <TaskCenterDrawer /> */}
        </Flex>
      </Flex>

      {/* {deliverableContainers.data.containers.length === 0 ? (
        <Text>No deliverables are currently configured.</Text>
      ) : (
        <>
          <DeliverablesPieChart
            containers={deliverableContainers.data.containers}
            onStatusFilterButtonClick={() => {}}
          />
          <DeliverablesTable
            containers={deliverableContainers.data.containers}
          />
        </>
      )} */}
    </>
  );
};

// Exports
export const permissions: PermissionsFn = () => 'allow';
export const Route = () => {
  return (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="/" />;
        }}
      >
        <Flex
          direction="column"
          padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
          gap="1.5rem"
        >
          <PermissionGuard
            permissions={(context) => {
              if (context.flags.enableDeliverablesV5) return 'deny';
              if (context.user.userType !== 'BORROWER') return 'deny';
              return 'allow';
            }}
          >
            <LegacyBorrowerRoute />
          </PermissionGuard>

          <PermissionGuard
            permissions={(context) => {
              if (context.flags.enableDeliverablesV5) return 'deny';
              if (context.user.userType !== 'CAPITAL_PROVIDER') return 'deny';
              return 'allow';
            }}
          >
            <LegacyLenderRoute />
          </PermissionGuard>

          <PermissionGuard
            permissions={(context) => {
              if (!context.flags.enableDeliverablesV5) return 'deny';
              return 'allow';
            }}
          >
            <RouteBase />
          </PermissionGuard>
        </Flex>
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
